import { UseMeResponse } from "@/hooks/use-me-query";

const selectUser = (data: UseMeResponse) => ({
  id: data.id,
  username: data.username,
  managerId: data.meta?.managerId as number | undefined,
  name: data.meta?.firstName as string | undefined,
  email: data.meta?.lastName as string | undefined,
  avatar: data.photoUrl || "",
  address: data.address,
  role: data.role,
});

export default selectUser;
